import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Infringement} from '../../intefaces/infringement.interface';
import {InfringementService} from '../../services/infringement.service';
import {FormGroup, FormBuilder, FormArray, FormControl} from '@angular/forms';
import {FormControlName} from '@angular/forms';
import {MatFormField} from '@angular/material/form-field';

@Component({
  selector: 'app-it-security-check',
  standalone: false,
  templateUrl: './it-security-check.component.html',
  styleUrl: './it-security-check.component.scss'
})

export class ItSecurityCheckComponent {
  identifier!: string;
  infringement!: Infringement;
  oderIDsForm!: FormGroup;
  comments!: FormGroup;
  isLoading: boolean = true;

  constructor(private route: ActivatedRoute, private infringementService: InfringementService, private fb: FormBuilder) {

  }

  ngOnInit(): void {
    this.isLoading = false;
    this.oderIDsForm = this.fb.group({
      oderIDs: this.fb.array([
        this.fb.control('')
      ])
    });

    this.comments = this.fb.group({
      genericComment: "",
    })
  }

  get oderIDs(): FormArray {
    return this.oderIDsForm.get('oderIDs') as FormArray;
  }

  addOrderID(): void {
    this.oderIDs.push(this.fb.control(''));
  }

  submitItSecurityCheck(): void {
    const orderIDs = this.oderIDs.value
      .map((id: string) => id?.trim())
      .filter((id: string | undefined): id is string => !!id);

    const commentText = (this.comments.get('genericComment')?.value ?? '').trim();
    const itSecurityComments = commentText
      ? [{
        date: new Date().toISOString(),
        comment: commentText
      }]
      : null;

    const payload = {
      checked: true,
      itSecurityComments,
      orderID: orderIDs.length ? orderIDs : null
    };

    console.log('Submitting IT security check payload', payload);
  }

  //testdata
  private loadInfringement(identifier: string): Infringement {
    return {
      "attachments": ["Gabba"],
      "identifier": "2024.226 U",
      "contractValue": 150654,
      "accused": {
        "name": "RIVERIT",
        "url": "https://riverit.net/company/partners/?sphrase_id=755",
        "email": "info@riverit.net",
        "country": "Ukraine",
        "countryCode": "UA",
        "address": "Shota Rustaveli St. 10, Kyiv"
      },
      "debitor": null,
      "infringementType": 1,
      "infringementStatus": 4,
      "infringementDetails": "No copyright info",
      "genericComments": [
        {
          "date": "2024-12-23",
          "comment": "Allet supi hier."
        }
      ],
      "responsibleEmployee": "Philipp.Ehinger@TecAlliance.net",
      "lastUpdatedBy": "Philipp.Ehinger@TecAlliance.net",
      "externalLawyer": null,
      "itSecurityCheck": {
        "checked": true,
        "itSecurityComments": [
          {
            "date": "2024-12-23",
            "comment": "Des sönd de Verbrecha!"
          }
        ],
        "orderID": ["8463846", "4123413"]
      },
      "dateCreated": "2024-12-23",
      "dateClosed": "2024-12-28",
      "warningSent": "2024-12-24",
      "reminderDate": "2024-12-25",
      "secondReminderDate": "2024-12-27",
      "warningDeadline": "2025-01-07",
      "reminderDeadline": "2025-01-08",
      "secondReminderDeadline": "2025-01-10"
    }
  }
}
